


































import { Component, Vue } from 'vue-property-decorator'
import api from '@/api'
import Separator from '../Separator/index.vue'
import VersionInfoTable from '../VersionInfoTable/index.vue'

@Component({ components: { Separator, VersionInfoTable } })
export default class FdpFooter extends Vue {
  info: any = { version: '', builtAt: '' }

  created() {
    this.fetchData()
  }

  async fetchData(): Promise<void> {
    const response = await api.info.getInfo()
    this.info = response.data
  }
}
